const budgetConciliationHeader = [
  {
    group: 'Orçamento BTLeo Líquido',
    columns: [
      {
        name: 'Id',
        id: 'orcamento-id',
        show: false
      },
      {
        name: 'Ano',
        id: 'orcamento-ano',
        show: true
      },
      {
        name: 'Mês',
        id: 'orcamento-mes',
        show: true
      },
      {
        name: 'Fator',
        id: 'orcamento-fator',
        show: true
      }
    ]
  }
]

export default budgetConciliationHeader
